import { APP_BANNER_SNOOZE_DAYS } from "./consts";

const SNOOZED_UNTIL_KEY = "tillix:app-banner-snoozed-until";
const DAY_MS = 24 * 60 * 60 * 1000;

type BannerStorage = Pick<Storage, "getItem" | "setItem">;

/** `localStorage`, or `null` where it is blocked (private mode, disabled site data). */
function browserStorage(): BannerStorage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function isAppBannerSnoozed(
  now: number = Date.now(),
  storage: BannerStorage | null = browserStorage(),
): boolean {
  try {
    const snoozedUntil = Number(storage?.getItem(SNOOZED_UNTIL_KEY));
    return Number.isFinite(snoozedUntil) && snoozedUntil > now;
  } catch {
    return false;
  }
}

/**
 * Hides the banner for {@link APP_BANNER_SNOOZE_DAYS}. Without storage it cannot be remembered, so the
 * banner comes back on the next visit, which is the safer failure than never showing it.
 */
export function snoozeAppBanner(
  now: number = Date.now(),
  storage: BannerStorage | null = browserStorage(),
): void {
  try {
    storage?.setItem(
      SNOOZED_UNTIL_KEY,
      String(now + APP_BANNER_SNOOZE_DAYS * DAY_MS),
    );
  } catch {
    // storage full or blocked: the banner will simply show again next time
  }
}
